import { createContext } from 'react';

/** @internal */
export interface NotificationSettingsContextType {
  enabled: boolean;
  hasReadPermission: boolean;
  hasWritePermission: boolean;
  toggleNotifications: () => Promise<void>;
  loading: boolean;
  hasNotFoundError: boolean;
}

const DEFAULT_CONTEXT: NotificationSettingsContextType = {
  enabled: true,
  hasReadPermission: true,
  hasWritePermission: true,
  toggleNotifications: () => Promise.resolve(),
  loading: false,
  hasNotFoundError: false,
};

/** @internal */
export const NotificationSettingsContext =
  createContext<NotificationSettingsContextType>(DEFAULT_CONTEXT);
